import { jsx as _jsx } from "react/jsx-runtime";
// LoadingComponent.tsx
const LoadingComponent = () => {
    return _jsx("div", { children: "Loading..." });
};
export default LoadingComponent;
